<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    status-module="aiGateway"
    :hiddenKeys="['zone', 'region']"
    resource="ai_gateways" />
</template>

<script>
import {
  getBrandTableColumn,
} from '@/utils/common/tableColumn'
import {
  getCollectLogsColumn,
  getCacheTtlColumn,
  getRequestRateLimitColumn,
  getAuthenticationColumn,
} from '../utils/columns'

export default {
  name: 'AiGatewayDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getBrandTableColumn(),
        getCollectLogsColumn(),
        getCacheTtlColumn(),
        getRequestRateLimitColumn(),
        getAuthenticationColumn(),
      ],
    }
  },
  created () {
  },
  methods: {
  },
}
</script>
